<script setup lang="ts">
  import type { MenuItem } from "primevue/menuitem"
  import { type PropType } from "vue"
  import AppMenuItem from "./AppMenuItem.vue"
  defineProps({
    model: {
      type: Array as PropType<MenuItem[]>,
      default: () => [],
    },
  })
</script>

<template>
  <ul class="layout-menu horizontal-menu">
    <template v-for="(item, i) in model" :key="item">
      <AppMenuItem :item="item" root :index="i" />
    </template>
  </ul>
</template>

<style lang="scss" scoped>
  .horizontal-menu {
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    list-style: none;
    margin: 0;
    padding: 0;
    align-items: center;
  }
</style>
